import { Component } from '@angular/core';

@Component({
  selector: 't-customer-management-icon',
  standalone: true,
  imports: [],
  templateUrl: './customer-management-icon.component.html',
  styleUrl: './customer-management-icon.component.css',
  host: { hostID: crypto.randomUUID().toString() },
})
export class CustomerManagementIconComponent {}
